import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {HttpHeaders} from "@angular/common/http";
import {HttpParams} from "@angular/common/http";

@Injectable()
export class ErrorInfoService {

  apiEndpoint = 'api';
  constructor(
    private httpClient: HttpClient
  ) { }

  list(): Observable<any> {

    let httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    let httpParams = new HttpParams().set('category', 'some category');

    return this.httpClient.get('../assets/data/errors.json', {
      responseType: 'json',
      params: httpParams,
      headers: httpHeaders
    });

  }
}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/error-info.service.ts